import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import styled from 'styled-components';
import DefaultIcon from '../../Icon';

const Icon = styled(DefaultIcon)`
  color: #444444;
`;

const DropdownIndicator = props => {
  const { selectProps } = props;
  return (
    <components.DropdownIndicator {...props}>
      {selectProps.menuIsOpen ? (
        <Icon className="fas fa-caret-up" />
      ) : (
        <Icon className="fas fa-caret-down" />
      )}
    </components.DropdownIndicator>
  );
};

DropdownIndicator.propTypes = {
  selectProps: PropTypes.shape({
    menuIsOpen: PropTypes.bool,
  }).isRequired,
};

export default DropdownIndicator;
